import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Home from '../containers/home';
import LandingImproveVocabulary from '../components/landing_improve_vocabulary';
import Privacy from '../components/privacy';
import TermsOfService from '../components/terms_of_service';
import AccountRouter from './account';
import PeopleRouter from './people';
import TacksRouter from './tacks';
import WordsRouter from './words';
import TackBoardRouter from './tack_board';
import PeopleBoardRouter from './people_board';
import SubscriptionRouter from './subscription';
import Plans from '../containers/plans';
import About from '../components/about';
import FourOhFour from '../components/four_oh_four';
import PropTypes from 'prop-types';

export default class Main extends React.Component {
  static propTypes = {
    onSetPath: PropTypes.func
  }

  state = {
    currentPathname: undefined
  }

  getSnapshotBeforeUpdate() {
    return window.scrollY;
  }

  componentDidMount() {
    this.setPath()
  }

  componentDidUpdate(prevProps, prevState, scrollY) {
    this.setPath(scrollY)
  }

  async setPath(scrollY = 0) {
    const newPathName = new window.URL(window.location.href).pathname;
    if (newPathName !== this.state.currentPathname) {
      await this.setState({ currentPathname: newPathName });
      this.props.onSetPath(newPathName, scrollY);
    }
  }

  render() {
    return(
      <Switch>
        <Route exact path="/" component={ Home } />
        <Route exact path="/improve_vocabulary_our_top_10" component={ LandingImproveVocabulary } />
        <Route path="/account/" component={ AccountRouter } />
        <Route path="/people/" component={ PeopleRouter } />
        <Route path="/tacks/" component={ TacksRouter } />
        <Route path="/words/" component={ WordsRouter } />
        <Route path="/tack_board" component={ TackBoardRouter } />
        <Route path="/people_board" component={ PeopleBoardRouter } />
        <Route path="/privacy" component={ Privacy } />
        <Route path="/terms_of_service" component={ TermsOfService } />
        <Route path='/subscription' component={ SubscriptionRouter } />
        <Route path="/plans" component={ Plans } />
        <Route path="/about" component={ About } />
        <Route component={ FourOhFour } />
      </Switch>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/main.jsx